import React from 'react';
import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';

const Description = props => {
  const { description, descriptionLines, name, theme } = props;
  if (!description || description.length === 0) return null;
  const episodeTitle = name ? (
    <div className={theme.episodeTitle}>
      <Dotdotdot clamp={1}>{name}</Dotdotdot>
    </div>
  ) : null;

  const text = descriptionLines ? (
    <Dotdotdot clamp={descriptionLines}>{description}</Dotdotdot>
  ) : (
    description
  );
  return (
    <div className={theme.descriptionBlock}>
      {episodeTitle}
      <div className={theme.description}>{text}</div>
    </div>
  );
};

Description.defaultProps = {
  description: null,
  descriptionLines: 4,
  name: null,
  theme: {},
};

Description.propTypes = {
  description: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  descriptionLines: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  theme: PropTypes.shape({}),
};

export default Description;
